import { render, staticRenderFns } from "./ActionsTable.vue?vue&type=template&id=7947affe&"
import script from "./ActionsTable.vue?vue&type=script&lang=js&"
export * from "./ActionsTable.vue?vue&type=script&lang=js&"
import style0 from "./ActionsTable.vue?vue&type=style&index=0&id=7947affe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports